import React from 'react';
import {Navbar, Image, Row, Col} from 'react-bootstrap';
import './Footer.css';

const Footer = function (props) {
    return (
        <Navbar className="footer-navbar" variant="dark" expand="" style={{backgroundColor:"rgb(43,43,43)", color:'white'}}>
             <Navbar.Brand href="#home" style={{height:"100%"}}>
                <img className = "footer-logo" src={"img/logos/standard-logo-files/original-on-transparent.png"}/>
            </Navbar.Brand> 
        
        
            <div className="footer-text" style={{}}>
                <p>CONTACT US<br/>
                <span>&#9993;</span> <span className="small-font"><a href="mailto:info@infinitysolutions.org.uk">info@infinitysolutions.org.uk</a></span><br></br>
                <span>&#9742;</span> <span className="small-font">07718 922168</span></p>
            </div>
        </Navbar>
    );
}

export default Footer;